import OrchestratorDisplay from '../../features/orchestrator/components/OrchestratorDisplay';

export default OrchestratorDisplay;
